import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import { Typography } from '@mui/material';

import conditionIsFlat from 'utils/conditionIsFlat';
import getUnitType from 'utils/getUnitType';

import styles from './SurfHeight.module.scss';

interface SurfHeightProps {
  min?: number;
  max?: number;
  units?: string;
  plus?: boolean;
}

const SurfHeight: FunctionComponent<SurfHeightProps> = ({
  min = 0,
  max = 0,
  units = '',
  plus = false,
}) => {
  const isFlat = conditionIsFlat(max, units);
  const className = classNames({
    [styles.surfHeight]: true,
    'quiver-surf-height': true,
    [styles.flat]: isFlat,
    'quiver-surf-height--flat': isFlat,
  });

  if (isFlat) {
    return <span className={className}>Flat</span>;
  }

  const range = min === max ? max : `${min}-${max}`;

  return (
    <>
      <Typography
        component="span"
        variant="callout2"
        className={className}
        data-testid="surf-height"
      >
        {range}
      </Typography>
      <Typography
        component="span"
        variant="callout2"
        className={classNames(styles.units, 'sl-surf-height-units')}
      >
        {getUnitType(units)}
        {plus && '+'}
      </Typography>
    </>
  );
};

export default SurfHeight;
